import { useEffect } from "react";

export function useServiceWorker() {
  useEffect(() => {
    if (
      process.env.NODE_ENV !== "development" &&
      "serviceWorker" in navigator
    ) {
      navigator.serviceWorker
        .register(`/sw.js?v=${process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA}`)
        .catch(() => {
          // Registration failures are non-fatal — the app works fine without SW.
          // Silencing here prevents unhandled rejections from ad blockers,
          // corporate firewalls, and other environments that block SW registration.
        });
    }
  }, []);
}
